// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonGrid } from "@ionic/react"
import SectionPage from "./SectionPage"
import './LandingPageGrid.scss'


interface LandingPageGridProps {
  children?: React.ReactNode
}


const LandingPageGrid: React.FC<LandingPageGridProps> = ({children}) => {
  return (
    <IonGrid className="landing">{children}</IonGrid>
  )
}


export { LandingPageGrid }